

import cynyIcon from 'Images/CLG.png';
import goalsIcon from 'Icons/project-icon-goals1.png';
import todoIcon from 'Icons/project-icon-todo.png';
import blogIcon from 'Icons/project-icon-blog.png';

import drumIcon from 'Icons/project-icon-drum.png';
import playlistIcon from 'Icons/project-icon-playlist.png';
import memoryIcon from 'Icons/project-icon-memory.png';
import diceIcon from 'Icons/project-icon-dice.png';
import tindogIcon from 'Icons/project-icon-tindog.png';
import robobnbIcon from 'Icons/project-icons-robobnb2.png';
import newsletterIcon from 'Icons/project-icon-newsletter.png';




export const projectsListValue = {

  cynycad: {
    name: 'CYNY CAD Website',
    tech: ['Express.JS', 'particle.JS', 'Jquery'],
    involvement: 'Major',
    link: {
      type: 'Website',
      value: 'https://cynycad.com/home'
    },
    icon: cynyIcon,
    description: [
      {
        type: 'text',
        highlight: 'dark',
        value: 'While working at CYNY CAD I was given the opportunity to design and build a new website for the company, creating custom artwork, CSS animations and much more along the way.'
      },

      {
        type: 'points',
        highlight: 'dark',
        title: "Overall I’m really pleased with how this project turned out and I invite anyone reading this to  follow the link above and check it out for themselves. I created the CYNY CAD website using Express.js to make the codebase both efficient and easy to use when more features are added in the future. The primary goal at the beginning of this project was to make the website have a more modern application feel to it and I believe we achieved that both functionally and aesthetically. While creating this website I learned a great deal about mobile responsiveness, CSS animations and media queries, all of which are  skills that I look forward to using in the future.  Here are some of the core features and technologies used:",
        screenshots:"Follow the website link above & check out screenshots of the project below.",
        value: [
          'Express.js',
        'JQuery',
        'Mobile Responsive',
        'Custom Animations',
        'Custom Graphic Design ',
        'Figma'

        ]
      }

    ]
  },
  goals: {
    name: 'Goals App',
    tech: ['react', 'Material UI', 'Javascript ES6'],
    involvement: 'Major',
    link: {
      type: 'visit website',
      value: 'https://goals-app-rk.herokuapp.com/'
    },
    icon: goalsIcon,
    description: [
      {
        type: 'text',
        highlight: 'dark',
        value: 'The Goals App is a React based web app that serves as a platform for people to share their goals and ambitions with the rest of the world. '
      },

      {
        type: 'points',
        highlight: 'dark',
        title: "I created this app as a way for me to practice React while  simultaneously learning how  to implement  authentication and security features. The Goals app uses Google authentication to handle user logins and passport.js to keep track of  user's cookies and sessions. Once a user is logged in they are able to share their individual goals and also view the goals of others. Additionally, the app is connected to an automated MongoDB Atlas database allowing users to read and post from anywhere in the world. Here are some of the core features:",
        screenshots:"Follow the website link above or check out screenshots of the project below.",
        value: [
          'Passport.js',
        'Google Oauth 2.0',
        'MongoDB Atlas',
        'Standard email authentication',
        'Material UI',
        'Bootstrap 5.0'

        ]
      }

    ]
  },


  robobnb: {
    name: 'airbnb clone',
    tech: ['react', 'material UI', 'flexbox'],
    involvement: 'Major',
    link: {
      type: 'website',
      value: 'https://airbnb-clone-7d19b.web.app/'
    },
    icon: robobnbIcon,
    description: [
      {
        type: 'text',
        highlight: 'blue',
        value: ' Robobnb is a front-end clone of the popular travel platform known as Airbnb. Airbnb’s website maintains a wide variety of  beautiful animations and features while remaining extremely simple and easy to use, it’s one of my favorite web applications which is why I decided to practice my front-end design skills and create a clone.'
      },
      {
        type: 'points',
        highlight: 'blue',
        title: " For this project I implemented React hooks and router to render with speed and efficiency. Additionally, the website's date picker allows users to easily filter stays by time frame and number of guests. The core features are listed below:",
        screenshots:'Follow the website link above or check out screenshots of the project below.',
        value: [
          'React Router/Hooks',

          'Flexbox',
          'Date picker',
          'Growing animations',
          'Material UI'
        ]
      },

    ]
  },

  blog: {
    name: 'Express.js Blog',
    tech: ['Node.js', 'Bootstrap', 'MongoDB Atlas'],
    involvement: 'Major',
    link: {
      type: 'website',
      value: 'https://blog-website-rk.herokuapp.com/'
    },
    icon: blogIcon,
    description: [
      {
        type: 'text',
        highlight: 'green',
        value: "This blog style website was created as a way for me to practice using Express.js in collaboration with a MongoDB database. I am able to compose blog posts by either writing within the website's composition portal or by adding to the database directly. The header and footer were created using bootstrap and Express.js partials."
      },
      {
        type: 'points',
        highlight: 'green',
        title: ' This was the very first project I created that pulls in data from a cloud database, in this case MongoDB Atlas, instead of a local database instance. In terms of the design I wanted to make sure  that the appearance was as simple as possible while highlighting the individual blog posts themselves. I learned a great deal from this project and I look forward to using that  knowledge for some of my next web application ideas. Some core features:',
        screenshots:"Follow the link above to check out the website or view the screenshots below."
        ,value: [
          'MongoDB Atlas Database',
          'Node.js',
          'Express.js',
          'Bootstrap CSS',
          'Heroku web hosting'
        ]
      },

    ]
  },
  todo: {
    name: 'Todo List',
    tech: ['EJS', 'MongoDB Atlas'], involvement: 'Major',
    link: {
      type: 'website',
      value: 'https://todo-list-app-rk.herokuapp.com/'
    },
    icon: todoIcon,
    description: [
      {
        type: 'text',
        highlight: 'orange',
        value: 'This todo list application was built as a way for me to practice implementing EJS(Embedded JavaScript) by defining HTML pages in the EJS syntax and specifying where data will go within those pages.  I connected the Todo List with a MongoDB cloud database which reads data directly into the the programs EJS templates and displays List Titles/Items.'
      },
      {
        type: 'points',
        highlight: 'orange',
        title: " I learned a great deal from connecting this project to a back-end database but I also had fun experimenting with the front-end design and I’m really happy with how everything turned out looking. Originally the project only had one ‘List’ but I recently added  a feature that allows users to create any list that they want and add/delete items as they see fit. Here are some of the project's core features:",
        screenshots:'Screenshots of the project below.',

        value: [
          'EJS templating',
          'MongoDB Atlas database',
          'Unique list creation',
          'Animated CSS background'
        ]
      }


    ]
  },

  drum: {
    name: 'Drum Simulator',
    tech: ['JavaScript'],
    involvement: 'Major',
    link: {
      type: 'website',
      value: 'https://drum-simulator.web.app/ '
    },
    icon: drumIcon,
    description: [

      {
        type: 'points',
        highlight: 'dark',
        title: 'The Drum Simulator project was created as a way for me to learn JavaScript functions and how they interact with HTML elements. In order to make a webpage that operates similarly to an electronic soundboard I imported audio files for 7 different types of drums and added JavaScript event listeners to make the drums ‘play’ when pressed. Here are some of the core features ',
        screenshots:'Screenshot of the project below. Feel free to click the link above and play some drums!',
        value: [
          'Animated buttons',
          'JavaScript event listeners',
          'Google fonts'
        ]
      },

    ]
  },

  playlist: {
    name: 'Playlist Finder',
    tech: [ 'React','Firebase'],
    involvement: 'Major',
    link: {
      type: 'visit website',
      value: 'https://playlist-finder-rk.web.app/'
    },
    icon: playlistIcon,
    description: [
      {
        type: 'text',
        highlight: 'blue',
        value: "Playlist Finder is a web app that allows users to browse, filter, upload and listen to music playlists all in one place. By taking advantage of Spotify’s fully responsive iframes, this playlist finder provides previews that actually allow users to listen  to music snippets before deciding on which playlist fits their exact needs. The filtering system allows users to narrow their search by ‘mood’ and ‘genre’ and easily resets with the press of a button. My favorite feature of this project is that users can upload playlists from anywhere  in the  world, by simply pasting the playlist's Spotify link and specifying its mood, genre or both."
      },
      {
        type: 'points',
        highlight: 'blue',
        title:"I created this web app with the goal of having a simple way to efficiently narrow down playlists and find exactly what I wanted to listen to. While using popular streaming services like Apple Music and Spotify I’ve found it very difficult to find playlists that fit both the mood and genre of what I’m looking for, so I set out to create an application that can do just that. This playlist finder is keyed towards Spotify playlists but in the future I plan to add Apple Music and other streaming services. It's powered by React and connected to a realtime Firebase database, which makes the querying extremely quick and responsive. Additionally, I’ve added a few security features in order to make sure that when a user uploads a playlist, the link that they submit is correctly formatted. Lastly, the next step for this web app will be adding user authentication and a ‘profile tab’ where people can track playlists they've uploaded or saved for the future. Here are some of its core features:",
        screenshots: "Please follow the link above and check out the project.",
        value: [

          'React Hooks',
          'XML',
          'Realtime Firebase Database',
          'Simple user uploading',
          'Interactive filtering',
          'Responsive playist components'
        ]
      },


    ]
  },

  memory: {
    name: 'Simon Memory Game',
    tech: ['JQuery', 'Animated Buttons'],
    involvement: 'Major',
    link: {
      type: 'play',
      value: 'https://memory-game-fd168.web.app/'
    },
    icon: memoryIcon,
    description: [

      {
        type: 'points',
        highlight: 'blue',
        title: 'The Simon Memory game is a pattern matching game built using Jquery, HTML and CSS. When a player lands on the website they are shown 4 distinctly colored buttons that animate and make sounds. In order to move on to the next level a player must correctly match the sequence which gets more and more difficult with time. Please give the game a try! Some core features:',
        screenshots: "Follow the link above and try out the game.",

        value: [
          "JQuery",
          'Event listeners',
          'Animated Buttons with sound',
          'Firebase hosting'

        ]
      }
    ]
  },

  dice: {
    name: 'Dice Roller',
    tech: [ 'JavaScript', 'google fonts'],
    involvement: 'Major',
    link: {
      type: 'Roll The Dice',
      value: 'https://dicegame-e364a.web.app/'
    },
    icon: diceIcon,
    description: [

      {
        type: 'points',
        highlight: 'blue',
        title: "The ‘Dice Roller’ is essentially a dice simulator that runs when the browser is refreshed, using JavaScript’s built-in random number generator to change the images of the dice and determine a winner. I used Google Fonts to help style the project and change the overall appearance. Next time you need to settle an argument, please feel free to open up the Dice Roller! Core features:",
        screenshots:'Screenshots of the project below.',
        value: [
          'JavaScript',
          'Google fonts',
          'Firebase hosting'

        ]
      },

    ]
  },

  tindog: {
    name: 'Tindog Dating',
    tech: ['Bootstrap','HTML'],
    involvement: 'Major',
    link: {
      type: 'website',
      value: 'https://tindog-b0079.web.app/'
    },
    icon: tindogIcon,
    description: [

      {
        type: 'points',
        highlight: 'red',
        title: "Tindog Dating is a project I created as part of a Udemy web development bootcamp that I enrolled in. The focus of this project was learning how to use Bootstrap 4.0 and it’s different features including grids, carousels, cards and breakpoints. The finished web page has three main sections: pricing, testimonials and an area to ‘download from the app store.’ Using Bootstrap has taught me how to create websites that are aesthetically pleasing and responsive for mobile viewing, because of this I definitely plan on using Bootstrap in my future projects from now on. Some of Tindog's core features:",
        screenshots:'Screenshots of the project below.',

        value: [
          'Bootstrap 4.0',
          'HTML',
          'CSS'
        ]
      }
    ]
  },

  newsletter: {
    name: 'Newsletter Mailchimp API',
    tech: ['Mailchimp API', 'Bootstrap'],
    involvement: 'Major',
    link: {
      type: 'website',
      value: 'https://robert-k-newsletter.herokuapp.com/'
    },

    icon: newsletterIcon,
    description: [

      {
        type: 'points',
        highlight: 'dark',
        title: 'This newsletter sign up page was created using the Mailchimp API in order to save contact  details such as full name and email. The Mailchimp API serves as a great way to organize contacts for future emails, updates or promotions. By  creating  this project I learned how to use API endpoints and how to deploy  a web page on Heroku. Some core features:',
        value: [
          'Bootstrap 4.0',
          'Custom Mailchimp audience ',
          'Heroku web hosting '
        ]
      }
    ]
  }
};
